module.exports = __webpack_public_path__ + "static/img/Video.b89c4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse/Video.jpg
// module id = 1953
// module chunks = 0